import { useEffect } from "react";
import { useStore } from "@/stores/useStore";
import { httpsCallables } from "@/repositories/httpsCallables";
import { syncServerClock } from "@/lib/serverClock";

const RESYNC_INTERVAL_MS = 10 * 60 * 1000;

/** Keeps the server clock offset fresh while a user is signed in. */
export const useServerClockSync = () => {
  const authUser = useStore((s) => s.authUser);
  const signedIn = !!authUser;

  useEffect(() => {
    if (!signedIn) return;
    const sync = () => {
      void syncServerClock(httpsCallables.getServerTime);
    };
    const onVisibility = () => {
      if (document.visibilityState === "visible") sync();
    };
    sync();
    const id = setInterval(sync, RESYNC_INTERVAL_MS);
    document.addEventListener("visibilitychange", onVisibility);
    return () => {
      clearInterval(id);
      document.removeEventListener("visibilitychange", onVisibility);
    };
  }, [signedIn]);
};
